import { ref, watch } from 'vue';
import { facilityFromRouteOrLastVisited } from '@/router';
import { crossAppActions } from '../../../cross-app-frontend/cross-app-actions';
import type { FacilityID } from '../../../tri-shared/types/db';

export interface FacilityPermissionSummary {
  hasUpdateBaseFacts: boolean;
  hasUpdateFacility: boolean;
  hasAdministerFacility: boolean;
  hasManageUsers: boolean;
  isSuperAdmin: boolean;
}

export const facilityPermissions = ref<Record<number, FacilityPermissionSummary>>({});

watch(
  facilityFromRouteOrLastVisited,
  async (facility) => {
    if (!facility) return;
    const facilityKey = facility.facilityID;
    if (facilityPermissions.value[facilityKey]) {
      return;
    }

    try {
      const summary = await crossAppActions.users.facilityPermissionSummary({
        facilityID: facility.facilityID as FacilityID,
      });
      facilityPermissions.value = {
        ...facilityPermissions.value,
        [facilityKey]: summary as FacilityPermissionSummary,
      };
    } catch (e) {
      console.error('Failed to load facility permission summary', e);
    }
  },
  { immediate: true },
);
